export default {
  //获取table 列表
  getMonthlyCalendarList: "/payroll/officeTimesheet/monthlyCalendar",
  // 新增打卡
  getAddAttendance:"/payroll/officeTimesheet/addFiles",
  // 查看详情
  getDetailPayRollById:"/payroll/officeTimesheet/detail",
  // 编辑
  getEditAttendance:"/payroll/officeTimesheet/edit",
  // 编辑新增文件
  getAddAttendanceFiles:"/payroll/officeTimesheet/addFiles",
  // 编辑删除文件
  getDeleAttendanceFiles:"/payroll/officeTimesheet/deleteFiles",
  // 展示日历
  getMonthlyData:"/payroll/managerTimesheet/monthlySummary",
  // 批量新增 编辑工作事项
  getManagerSave:"/payroll/managerTimesheet/save",
  // 删除单个事项
  getManagerDele:"/payroll/managerTimesheet/deleteItem",
  // 获取打卡时间段
  getCheckManagerTime:"/payroll/managerTimesheet/checkManagerTime",
  // 管理员获取名下所有人员
  getAccountDict:"/payroll/managerTimesheet/getAccountDict",
};
